import api from './apiClient';

export const askAi = async (message, reportContext = '', reportId = '', workspaceId = '', conversationHistory = [], activeFilters = '') => {
  const response = await api.post('/AiChat/ask', {
    message,
    reportContext,
    reportId,
    workspaceId,
    conversationHistory,
    activeFilters
  });
  return response.data;
};